import React from "react";
import { BsCheckCircleFill } from "react-icons/bs";
import { FaStar } from "react-icons/fa";

const guides = [
  {
    title: "Golden Triangle Tour",
    description:
      "Explore Delhi, Agra, and Jaipur in one classic route. See the Taj Mahal, Amber Fort, and bustling markets.",
    highlights: [
      "Delhi: Red Fort, Qutub Minar",
      "Agra: Taj Mahal, Fatehpur Sikri",
      "Jaipur: Amber Fort, City Palace",
    ],
  },
  {
    title: "Spiritual South India",
    description:
      "Discover temples, beaches, and culture in Tamil Nadu and Kerala. Perfect for a peaceful getaway.",
    highlights: [
      "Madurai: Meenakshi Temple",
      "Rameswaram: Pilgrimage",
      "Kerala: Backwaters, Houseboats",
    ],
  },
  {
    title: "Adventure in the Himalayas",
    description:
      "Trek, camp, and explore the mountains of Himachal and Uttarakhand. Ideal for thrill-seekers.",
    highlights: [
      "Manali: Rohtang Pass",
      "Rishikesh: River Rafting",
      "Leh-Ladakh: Bike Trip",
    ],
  },
];

const TravelGuides = () => {
  return (
    <div
      className="min-h-screen bg-white"
      style={{
        fontFamily: "'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        paddingTop: "80px",
      }}
    >
      <header
        style={{
          background: "linear-gradient(135deg, #EE2E24 0%, #FFC400 100%)",
          padding: "45px 0",
          marginBottom: "32px",
        }}
      >
        <div className="container mx-auto text-center">
          <h1
            style={{
              fontSize: "clamp(1.75rem, 4vw, 2.5rem)",
              fontWeight: "800",
              color: "white",
              marginBottom: "8px",
              letterSpacing: "-1px",
              textShadow: "0 2px 10px rgba(0,0,0,0.2)",
            }}
          >
            Travel Guides
          </h1>
          <p
            style={{
              color: "white",
              fontSize: "clamp(0.95rem, 2vw, 1.1rem)",
              opacity: 0.95,
              fontWeight: "500",
            }}
          >
            Handpicked routes and tips for your next Indian adventure
          </p>
        </div>
      </header>
      <main className="container mx-auto px-4 py-6">
        <section style={{ marginBottom: "48px" }}>
          <h2
            style={{
              fontSize: "clamp(1.5rem, 3.5vw, 2rem)",
              fontWeight: "800",
              marginBottom: "24px",
              color: "#2E2E2E",
              textAlign: "center",
              letterSpacing: "-1px",
            }}
          >
            Popular Guides
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {guides.map((guide, idx) => (
              <div
                key={idx}
                style={{
                  background: "white",
                  borderRadius: "14px",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                  padding: "24px 20px",
                  border: "2px solid #F1F5F9",
                  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-6px)";
                  e.currentTarget.style.boxShadow =
                    "0 15px 40px rgba(238, 46, 36, 0.15)";
                  e.currentTarget.style.borderColor = "#EE2E24";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 20px rgba(0,0,0,0.08)";
                  e.currentTarget.style.borderColor = "#F1F5F9";
                }}
              >
                <h3
                  style={{
                    fontSize: "1.3rem",
                    fontWeight: "800",
                    color: "#2E2E2E",
                    marginBottom: "8px",
                    letterSpacing: "-0.6px",
                  }}
                >
                  {guide.title}
                </h3>
                <p
                  style={{
                    color: "#64748B",
                    marginBottom: "16px",
                    fontSize: "0.9rem",
                    lineHeight: "1.5",
                    fontWeight: "500",
                  }}
                >
                  {guide.description}
                </p>
                <ul style={{ marginTop: "16px" }}>
                  {guide.highlights.map((h, i) => (
                    <li
                      key={i}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        color: "#2E2E2E",
                        marginBottom: "8px",
                        fontSize: "0.875rem",
                      }}
                    >
                      <BsCheckCircleFill
                        style={{
                          marginRight: "8px",
                          color: "#22C55E",
                          fontSize: "1rem",
                          flexShrink: 0,
                        }}
                      />
                      <span style={{ fontWeight: "500" }}>{h}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>
        <section
          style={{
            background:
              "linear-gradient(135deg, rgba(238, 46, 36, 0.05) 0%, rgba(255, 196, 0, 0.05) 100%)",
            borderRadius: "14px",
            padding: "32px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
            maxWidth: "900px",
            margin: "0 auto",
            marginTop: "48px",
          }}
        >
          <h2
            style={{
              fontSize: "clamp(1.5rem, 3.5vw, 2rem)",
              fontWeight: "800",
              marginBottom: "24px",
              color: "#2E2E2E",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              letterSpacing: "-1px",
            }}
          >
            <FaStar style={{ color: "#FFC400", fontSize: "1.8rem" }} />{" "}
            Essential Tips for Travelers{" "}
            <FaStar style={{ color: "#FFC400", fontSize: "1.8rem" }} />
          </h2>
          <ul style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <li
              style={{
                background: "white",
                borderRadius: "10px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                padding: "18px 20px",
                display: "flex",
                alignItems: "center",
                gap: "14px",
                border: "1px solid rgba(238, 46, 36, 0.1)",
              }}
            >
              <BsCheckCircleFill
                style={{ color: "#22C55E", fontSize: "1.2rem", flexShrink: 0 }}
              />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span
                  style={{
                    fontWeight: "700",
                    color: "#2E2E2E",
                    fontSize: "0.9rem",
                    letterSpacing: "-0.3px",
                  }}
                >
                  Book tickets and hotels in advance for best prices.
                </span>
                <a
                  href="/HotelRoomsPage"
                  style={{
                    marginTop: "6px",
                    color: "#EE2E24",
                    textDecoration: "underline",
                    fontWeight: "600",
                    fontSize: "0.875rem",
                    transition: "color 0.2s ease",
                  }}
                  onMouseEnter={(e) => (e.target.style.color = "#D82820")}
                  onMouseLeave={(e) => (e.target.style.color = "#EE2E24")}
                >
                  Book Now
                </a>
              </div>
            </li>
            <li
              style={{
                background: "white",
                borderRadius: "10px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                padding: "18px 20px",
                display: "flex",
                alignItems: "center",
                gap: "14px",
                border: "1px solid rgba(238, 46, 36, 0.1)",
              }}
            >
              <BsCheckCircleFill
                style={{ color: "#22C55E", fontSize: "1.2rem", flexShrink: 0 }}
              />
              <span
                style={{
                  fontWeight: "700",
                  color: "#2E2E2E",
                  fontSize: "0.9rem",
                  letterSpacing: "-0.3px",
                }}
              >
                Respect local customs and dress codes, especially at religious
                sites.
              </span>
            </li>
            <li
              style={{
                background: "white",
                borderRadius: "10px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                padding: "18px 20px",
                display: "flex",
                alignItems: "center",
                gap: "14px",
                border: "1px solid rgba(238, 46, 36, 0.1)",
              }}
            >
              <BsCheckCircleFill
                style={{ color: "#22C55E", fontSize: "1.2rem", flexShrink: 0 }}
              />
              <span
                style={{
                  fontWeight: "700",
                  color: "#2E2E2E",
                  fontSize: "0.9rem",
                  letterSpacing: "-0.3px",
                }}
              >
                Try local food, but be mindful of hygiene.
              </span>
            </li>
            <li
              style={{
                background: "white",
                borderRadius: "10px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                padding: "18px 20px",
                display: "flex",
                alignItems: "center",
                gap: "14px",
                border: "1px solid rgba(238, 46, 36, 0.1)",
              }}
            >
              <BsCheckCircleFill
                style={{ color: "#22C55E", fontSize: "1.2rem", flexShrink: 0 }}
              />
              <span
                style={{
                  fontWeight: "700",
                  color: "#2E2E2E",
                  fontSize: "0.9rem",
                  letterSpacing: "-0.3px",
                }}
              >
                Keep emergency contacts and travel insurance handy.
              </span>
            </li>
            <li
              style={{
                background: "white",
                borderRadius: "10px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                padding: "18px 20px",
                display: "flex",
                alignItems: "center",
                gap: "14px",
                border: "1px solid rgba(238, 46, 36, 0.1)",
              }}
            >
              <BsCheckCircleFill
                style={{ color: "#22C55E", fontSize: "1.2rem", flexShrink: 0 }}
              />
              <span
                style={{
                  fontWeight: "700",
                  color: "#2E2E2E",
                  fontSize: "0.9rem",
                  letterSpacing: "-0.3px",
                }}
              >
                Use Google Maps and local guides for navigation.
              </span>
            </li>
          </ul>
        </section>
      </main>
    </div>
  );
};

export default TravelGuides;
